import { render, staticRenderFns } from "./SupplyPalletIndexMirror.vue?vue&type=template&id=5f856e04"
import script from "./SupplyPalletIndexMirror.vue?vue&type=script&lang=js"
export * from "./SupplyPalletIndexMirror.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports